import { PagingInfoModel } from "../query/paging-info-model";

export class CategorySearchModel extends PagingInfoModel {
    property: any;
}